"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityQuoteCoverDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_quote_entry_entity_1 = require("./opportunity-quote-entry.entity");
let OpportunityQuoteCoverDetail = class OpportunityQuoteCoverDetail {
};
exports.OpportunityQuoteCoverDetail = OpportunityQuoteCoverDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteCoverDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteCoverDetail.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteCoverDetail.prototype, "quoteId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_map_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteCoverDetail.prototype, "coverMapId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteCoverDetail.prototype, "policyTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteCoverDetail.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_cover_response", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteCoverDetail.prototype, "insurerCoverResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityQuoteCoverDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityQuoteCoverDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteCoverDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteCoverDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_quote_entry_entity_1.OpportunityQuoteEntry, (quote) => quote.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "quote_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof opportunity_quote_entry_entity_1.OpportunityQuoteEntry !== "undefined" && opportunity_quote_entry_entity_1.OpportunityQuoteEntry) === "function" ? _c : Object)
], OpportunityQuoteCoverDetail.prototype, "quote", void 0);
exports.OpportunityQuoteCoverDetail = OpportunityQuoteCoverDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_quote_cover_detail")
], OpportunityQuoteCoverDetail);
